import React from 'react';
import propTypes from 'prop-types';
export const FoodDrinkIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      fill={color}
      width={sizeInPixel}
      height={sizeInPixel}
      viewBox="0 0 50 50"
      version="1.2"
      baseProfile="tiny"
      xmlns="http://www.w3.org/2000/svg"
      overflow="inherit"
    >
      <path d="M48.894 15.154l-3.935 30.846h-13.291l-3.919-31h16.226l3.207-11.077 1.818.548-3.077 10.66 2.971.023zm-23.024 17.846s.497-4-6.395-4h-10.976c-6.882 0-6.395 4-6.395 4h23.766zm-23.766 9s-.487 4 6.395 4h10.977c6.892 0 6.395-4 6.395-4h-23.767zm22.735-2c1.128 0 2.039-1.114 2.039-2.499 0-1.393-.911-2.501-2.039-2.501h-21.799c-1.123 0-2.04 1.108-2.04 2.501 0 1.385.917 2.499 2.04 2.499h21.799z" />
    </svg>
  );
};
FoodDrinkIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
FoodDrinkIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
